import { atom } from '@exodus/headless-ui';
const swapModeAtom = atom('ExactIn');
export default swapModeAtom;
